import { useQueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";

import { novaClient } from "@/lib/trpc";

export function useUpdateProfileUser() {
  const queryClient = useQueryClient();

  const mutation = novaClient.internal.user.active.update.useMutation({
    // Hook-level so caches stay in sync even when the calling editor unmounts
    // before the mutation resolves (mutate()-level callbacks are skipped then).
    onSuccess: (_updatedUser, variables) => {
      const data = variables.data as {
        currentPay?: number | null;
        desiredPay?: number | null;
        professionalSummary?: string | null;
      };
      if (
        data.currentPay === undefined &&
        data.desiredPay === undefined &&
        data.professionalSummary === undefined
      ) {
        return;
      }

      queryClient.setQueriesData(
        {
          predicate: (query) => {
            const [, params] = query.queryKey as [
              unknown,
              { input?: { userId?: number } }?,
            ];
            return params?.input?.userId === variables.userId;
          },
          queryKey: getQueryKey(
            novaClient.internal.user.active.getCandidacySheetData,
          ),
        },
        (cached: unknown) => {
          if (!cached) return cached;
          const cachedData = cached as {
            professionalSummary?: string | null;
            profile?: Record<string, unknown>;
          };
          return {
            ...cachedData,
            ...(data.professionalSummary !== undefined && {
              professionalSummary: data.professionalSummary,
            }),
            profile: {
              ...cachedData.profile,
              ...(data.currentPay !== undefined && {
                currentPay: data.currentPay,
              }),
              ...(data.desiredPay !== undefined && {
                desiredPay: data.desiredPay,
              }),
            },
          };
        },
      );
    },
  });

  return mutation;
}
